// Chakra imports
import { Flex, Text, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card.js";
import PieChart from "components/charts/PieChart";
import React from "react";

export default function KodeSuratKeluarStatistik(props) {
  const { key, dataKodeSukel, kategoriKodeSukel } = props;

  // Chakra Color Mode
  const textColor = useColorModeValue("secondaryGray.900", "white");
  const cardColor = useColorModeValue("white", "navy.700");
  const cardShadow = useColorModeValue(
    "0px 18px 40px rgba(112, 144, 176, 0.12)",
    "unset"
  );
  return (
    <Card p='20px' align='center' direction='column' w='100%'>
      <Flex
        px={{ base: "0px", "2xl": "10px" }}
        justifyContent='space-between'
        alignItems='center'
        w='100%'
        mb='8px'>
        <Text color={textColor} fontSize='md' fontWeight='600' mt='4px'>
          Kode Surat Keluar Terpakai
        </Text>
      </Flex>

      {key}
      <PieChart
        h='100%'
        w='100%'
        chartData={dataKodeSukel}
        chartOptions={{
          labels: kategoriKodeSukel,
          chart: {
            width: "50px",
          },
          states: {
            hover: {
              filter: {
                type: "none",
              },
            },
          },
          legend: {
            show: false,
          },
          dataLabels: {
            enabled: false,
          },
          hover: { mode: null },
          plotOptions: {
            donut: {
              expandOnClick: false,
              donut: {
                labels: {
                  show: false,
                },
              },
            },
          },
          tooltip: {
            enabled: true,
            theme: "dark",
          },
        }}
      />

      <Card
        bg={cardColor}
        flexDirection='row'
        boxShadow={cardShadow}
        w='100%'
        p='15px'
        px='20px'
        mt='15px'
        mx='auto'>
        <Flex direction='column' py='5px' textAlign='left'>
          <Text color={textColor}>
            * Nomor urut surat direset ke 0 setiap tanggal 1 Januari
          </Text>
        </Flex>
      </Card>
    </Card>
  );
}
